(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();
	var documentHeight = $(document).height();

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var topmenuHeight = $('.topMenu').outerHeight();
	var sitemenuHeight = $('.siteMenu').outerHeight();
	var headerHeight = $('#site-header').outerHeight();

	$(window).scroll(function(event){
	    didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 10);

	function hasScrolled() {
	    var st = $(this).scrollTop();

	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;

	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
			if (st < 72){
				if(windowWidth > 767) {
					$('#site-header').css('top','0px');
					$('body').removeClass('scrolled');
				}
				else {
					$('#site-header').css('top','0px');
					$('body').removeClass('scrolled');
				}
			}
	    else if (st > lastScrollTop && st > 5){
	        // Scroll Down
	       if(windowWidth > 767) {
						$('#site-header').css('top',-headerHeight);
					}
					else {
						$('#site-header').css('top',-72);
					}
	    } else {
	        // Scroll Up
					if (st + windowHeight < documentHeight) {
						if(windowWidth > 767) {
				  		$('#site-header').css('top',-topmenuHeight);
							$('body').addClass('scrolled');
				  	}
						else {
							$('#site-header').css('top','0px');
							$('body').removeClass('scrolled');
						}
					}
	    }
	    lastScrollTop = st;
	}

	/* Document ready functions */
	$(document).ready(function (){

		setTimeout(function () {
			// Get Window Width and Height on resize
			windowWidth = $(window).outerWidth();
			windowHeight = $(window).height();
			documentHeight = $(document).height();
			messageHeight = $('.important-message').outerHeight();
			topmenuHeight = $('.topMenu').outerHeight();
			sitemenuHeight = $('.siteMenu').outerHeight();
			headerHeight = $('#site-header').outerHeight();

			$('body').css('padding-top',headerHeight);

		}, 200);

	});

	$(window).resize(function () {

		setTimeout(function () {
			// Get Window Width and Height on resize
			windowWidth = $(window).outerWidth();
			windowHeight = $(window).height();
			documentHeight = $(document).height();
			messageHeight = $('.important-message').outerHeight();
			topmenuHeight = $('.topMenu').outerHeight();
			sitemenuHeight = $('.siteMenu').outerHeight();
			headerHeight = $('#site-header').outerHeight();

			$('body').css('padding-top',headerHeight);

		}, 200);

	});

})(jQuery);
